var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 12.24C34.3001 11.2 33.5 10.64 32.7 10.56C31.82 10.4 31.1 10.56 30.54 11.04C29.9 11.44 29.54 12.08 29.46 12.96C29.3801 13.84 29.7401 14.8 30.54 15.84C31.82 17.52 32.7401 19.24 33.3 21C33.78 22.68 34.02 24.24 34.02 25.68L34.38 23.28C32.3 23.28 30.62 23.88 29.34 25.08C28.0601 26.2001 27.42 27.7601 27.42 29.76C27.42 31.68 28.02 33.2801 29.22 34.56C30.42 35.76 31.98 36.36 33.9 36.36C35.9801 36.36 37.62 35.6801 38.82 34.32C39.9401 32.88 40.5 30.84 40.5 28.2C40.5 26.52 40.38 24.8 40.14 23.04C39.8201 21.2 39.26 19.36 38.46 17.52C37.58 15.68 36.4601 13.92 35.1 12.24ZM15.18 12.24C14.38 11.2 13.58 10.64 12.78 10.56C11.9 10.4 11.18 10.56 10.62 11.04C9.98 11.44 9.62 12.08 9.54 12.96C9.45999 13.84 9.81999 14.8 10.62 15.84C11.9 17.52 12.82 19.24 13.38 21C13.86 22.68 14.1 24.24 14.1 25.68L14.46 23.28C12.38 23.28 10.7 23.88 9.42 25.08C8.13999 26.2001 7.5 27.7601 7.5 29.76C7.5 31.68 8.1 33.2801 9.3 34.56C10.5 35.76 12.06 36.36 13.98 36.36C16.06 36.36 17.7 35.6801 18.9 34.32C20.02 32.88 20.58 30.84 20.58 28.2C20.58 26.52 20.46 24.8 20.22 23.04C19.9 21.2 19.34 19.36 18.54 17.52C17.66 15.68 16.54 13.92 15.18 12.24Z",
    fill: "#06DE54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.667c516acf63b652811cdf4fd63ca928.svg";
export { ForwardRef as ReactComponent };